module.exports = __webpack_public_path__ + "img/@logo_skenergy.a1923787.png";